var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0428\\u0430\\u0440_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 793.7",
    style: {
      enableBackground: "new 0 0 595.28 793.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0066B3;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st3{fill:#5AB685;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#5AB685;}\r\n\t.st5{fill:#6D6E71;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#0066B3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M581.02,395.63V11.9H14.22v384c0,0-0.09,1.64-0.09,5.1c0.22,39.03,14.94,240.33,283.05,366.74l0.48,0.2 l0.43-0.2c268.04-126.35,282.77-327.71,283.05-366.8C581.15,397.51,581.05,395.91,581.02,395.63z M298.02,731l-0.35,0.21 l-0.45-0.21C58.52,616.02,45.39,432.97,45.14,397.43c0-3.15,0.13-4.63,0.13-4.63V43.48H550v349.05c0.02,0.22,0.08,1.71,0.08,4.85 C549.84,432.97,536.68,616.06,298.02,731z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M581.02,395.63V11.9H14.22v384c0,0-0.09,1.64-0.09,5.1c0.22,39.03,14.94,240.33,283.05,366.74l0.48,0.2 l0.43-0.2c268.04-126.35,282.77-327.71,283.05-366.8C581.15,397.51,581.05,395.91,581.02,395.63z M298.02,731l-0.35,0.21 l-0.45-0.21C58.52,616.02,45.39,432.97,45.14,397.43c0-3.15,0.13-4.63,0.13-4.63V43.48H550v349.05c0.02,0.22,0.08,1.71,0.08,4.85 C549.84,432.97,536.68,616.06,298.02,731z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.77,501.3v31.09h31.29V501.3h15.65v77.2h-15.65V545.1h-31.29v33.41h-15.7v-77.2H156.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.07,501.3l15.28,32.87l3.29,8.14h0.39l3.3-8.25L267,501.3h15.39l-30.83,65.69 c-4.35,9.19-10.18,12.38-18.29,12.38c-3.68,0-7.65-0.69-11.7-2.46l1.75-11.67c2.21,1.1,4.08,1.64,6.62,1.64 c2.96,0,6.48-0.07,8.71-5.16l2.22-5.17l-28.32-55.26H230.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M340.68,501.3V515h-33.77v16.05h12.56c22.7,0,27.46,15.07,27.46,24.96c0,8.15-5.41,22.5-27.46,22.5h-28.24 v-77.2H340.68z M306.91,566.34h9.65c8.76,0,13.8-3.71,13.8-11.58c0-7.79-5.04-11.54-13.8-11.54h-9.65V566.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.24,501.3h15.65v77.2h-15.65V501.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M454.19,501.3v77.2h-15.65v-64.53h-30.55v64.53h-15.69v-77.2H454.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.03,617.8v46.05h-9.34v-35.99l-7.87,6.93l-4.39-5.47l13.21-11.52H248.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M257.52,629.6c0-7.59,6.47-12.31,15.05-12.31c8.91,0,15.01,4.4,15.01,11.44c0,4.47-2.4,8.6-7.11,10.33 c5.12,1.78,8.47,5.88,8.47,11.66c0,9.1-7.83,13.61-16.37,13.61c-11.87,0-16.36-6.87-16.36-13.53c0-5.28,3.15-9.46,8.13-11.1 C259.97,637.79,257.52,634.05,257.52,629.6z M265.74,651.01c0,3.91,3.39,6.1,6.83,6.1c5.01,0,6.84-3.35,6.84-6.1 c0-3.19-2.9-5.69-7.7-7.47C266.19,645.99,265.74,649.42,265.74,651.01z M278.78,629.55c0-2.7-2.4-5.24-6.21-5.24 c-3.37,0-6.16,2.22-6.16,5.24c0,3.43,3.24,5.02,6.81,6.51C276.16,634.96,278.78,632.27,278.78,629.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.43,655.42c2.51,1.06,5.6,1.69,8.21,1.69c9.66,0,11.12-8.58,11.16-13.05h-0.21 c-1.95,2.67-4.54,4.53-8.8,4.53c-8.15,0-14.34-5.42-14.34-15.07c0-7.99,4.02-16.24,15.93-16.24c15.5,0,16.62,13.53,16.62,22.3 c0,21.55-11.24,24.75-19.61,24.75c-3.91,0-6.85-0.39-10.03-1.47L299.43,655.42z M317.94,632.92c0-6.23-2.9-8.38-6.29-8.38 c-3.42,0-6.36,2.15-6.36,8.38c0,6.28,2.94,8.42,6.36,8.42C315.04,641.34,317.94,639.2,317.94,632.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M335.88,629.6c0-7.59,6.4-12.31,15-12.31c8.91,0,15.07,4.4,15.07,11.44c0,4.47-2.42,8.6-7.18,10.33 c5.15,1.78,8.5,5.88,8.5,11.66c0,9.1-7.85,13.61-16.39,13.61c-11.87,0-16.35-6.87-16.35-13.53c0-5.28,3.13-9.46,8.15-11.1 C338.28,637.79,335.88,634.05,335.88,629.6z M344.03,651.01c0,3.91,3.41,6.1,6.85,6.1c5.06,0,6.83-3.35,6.83-6.1 c0-3.19-2.85-5.69-7.65-7.47C344.49,645.99,344.03,649.42,344.03,651.01z M357.07,629.55c0-2.7-2.4-5.24-6.19-5.24 c-3.38,0-6.16,2.22-6.16,5.24c0,3.43,3.3,5.02,6.85,6.51C354.47,634.96,357.07,632.27,357.07,629.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.95,311.3c20.28,21.15,31.13,43.77,33.65,58.62h-16.46c-2.81-17.7-6.9-28.71-21.13-56.47L239.95,311.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.54,369.92 286.39,369.92 294.11,296.27 298.5,296.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "340.05,392.73 251.92,392.73 254.82,378.01 337.31,378.01  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.06,459.24c0,0,17.17,6.98,24.65,8.05l23.37-65.67l-6.7-0.55h-5.62L223.06,459.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.8,401.62l23.29,65.67c7.54-1.07,24.69-8.05,24.69-8.05l-35.66-58.18h-5.69L317.8,401.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.94,472.44c0,0,13.53,0.76,16.45,0.48h0.02c2.98,0.29,16.47-0.48,16.47-0.48l-9.43-71.37h-14.11 L277.94,472.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M294.5,159.14c11.81,2.23,7.65-12.26,7.65-12.26l-3.52-12.07l2.01-63.78l-9.01,1.71l0.13,65.32 C291.77,138.06,282.69,156.85,294.5,159.14z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.64,172.1c-1.96,9.37,1.39,14.51,1.39,14.51s12.54,1.48,13.73-19.14c1.25-20.55,3.87-84.76,3.87-84.76 l-6.94,2.18c0,0-3.67,65.51-4.67,73.59C306.04,166.56,301.67,162.71,299.64,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.64,172.1c1.99,9.37-1.37,14.51-1.37,14.51s-12.52,1.48-13.75-19.14c-1.21-20.55-3.87-84.76-3.87-84.76 l6.94,2.18c0,0,3.7,65.51,4.69,73.59C285.24,166.56,289.63,162.71,291.64,172.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.16,253.66c24.87,15.58,27.33-32.56,27.33-32.56S286.47,231.34,300.16,253.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.16,289.34c24.87,15.59,27.33-32.56,27.33-32.56S286.47,266.96,300.16,289.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.84,194.26L327.84,194.26l5.06-49.2c2.01-32.76-1.1-44.14-1.15-44.38l-6.77,0.68 c0.04,0.25,3.09,11.12,1.04,43.33l-4.35,43.99c-11.07,3.1-31.24,11.18-22.12,28.83C317.13,230.29,324.98,207.01,327.84,194.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.14,253.66c-24.84,15.58-27.31-32.56-27.31-32.56S304.85,231.34,291.14,253.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.14,289.34c-24.84,15.59-27.31-32.56-27.31-32.56S304.85,266.96,291.14,289.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M263.47,194.26L263.47,194.26l-5.02-49.2c-2.04-32.76,1.06-44.14,1.06-44.38l6.85,0.68 c-0.02,0.25-3.09,11.12-1.06,43.33l4.84,43.21c11.07,3.11,30.77,11.96,21.63,29.61C274.17,230.29,266.35,207.01,263.47,194.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.51,213.79c9.84-3.74-0.95-12.39-0.95-12.39l-8.93-7.23l-32.37-47.42l-5.69,5.3l34.73,47.64 C150.3,199.69,153.7,217.56,163.51,213.79z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174.19,220.91c3.52,7.76,8.71,9.95,8.71,9.95s9.9-4.61-0.09-20.2c-10.08-15.55-42.18-63.65-42.18-63.65 l-3.94,4.8c0,0,32.11,49.48,35.67,55.77C175.9,213.96,170.67,213.16,174.19,220.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.29,224.63c6.45,5.88,6.71,11.18,6.71,11.18s-8.37,6.77-20.18-7.66 C143.02,213.63,107,167.97,107,167.97l6.22-1.54c0,0,37.45,46.12,42.44,51.57C160.72,223.45,161.83,218.66,168.29,224.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M217.8,280.24c26.47,0.11,2.71-36.18,2.71-36.18S195.95,270.16,217.8,280.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.75,306.3c26.47,0.06,2.68-36.23,2.68-36.23S214.91,296.22,236.75,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.5,224.29L206.5,224.29l-22.47-38.2c-15.89-24.86-24.15-31.76-24.33-31.96l-4.61,3.63 c0.15,0.14,8.15,6.73,23.83,31.15l20.11,34.12c-6.48,7.3-16.89,22.4-0.89,31.09C217.76,255.41,211.17,234.88,206.5,224.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M211.23,284.34c-9.9,22.73-37.21-11.34-37.21-11.34S209.37,261.79,211.23,284.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.18,310.43c-9.88,22.71-37.26-11.36-37.26-11.36S228.32,287.86,230.18,310.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.45,253.61L159.45,253.61l-29.75-33.63c-18.88-23-22.68-32.76-22.77-32.91l5.34-2.61 c0.09,0.2,3.67,9.57,22.26,32.15l27.44,29.87c9.71-2.74,27.86-5.82,30.55,11.16C186.41,275.02,168.33,261.6,159.45,253.61z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.31,311.3c-20.32,21.15-31.11,43.77-33.67,58.62h16.45c2.86-17.7,6.68-28.1,20.87-55.93L352.31,311.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M428.75,213.79c-9.82-3.74,0.93-12.39,0.93-12.39l8.97-7.23l32.35-47.42l5.71,5.3l-34.74,47.64 C441.98,199.69,438.56,217.56,428.75,213.79z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M418.13,220.91c-3.55,7.76-8.72,9.95-8.72,9.95s-9.97-4.61,0.08-20.2c10.08-15.55,42.19-63.65,42.19-63.65 l3.94,4.8c0,0-32.11,49.48-35.7,55.77C416.36,213.96,421.63,213.16,418.13,220.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M423.99,224.63c-6.44,5.88-6.71,11.18-6.71,11.18s8.35,6.77,20.17-7.66 c11.81-14.51,47.82-60.18,47.82-60.18l-6.23-1.54c0,0-37.43,46.12-42.42,51.57C431.55,223.45,430.41,218.66,423.99,224.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374.45,280.24c-26.44,0.11-2.64-36.18-2.64-36.18S396.36,270.16,374.45,280.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M355.54,306.3c-26.47,0.06-2.73-36.23-2.73-36.23S377.39,296.22,355.54,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385.78,224.29L385.78,224.29l22.42-38.2c15.91-24.86,24.22-31.76,24.37-31.96l4.61,3.63 c-0.15,0.14-8.17,6.73-23.8,31.15l-20.05,34.17c6.4,7.28,16.78,22.35,0.74,31.04C374.45,255.41,381.09,234.88,385.78,224.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M381.01,284.34c9.9,22.73,37.27-11.34,37.27-11.34S382.93,261.79,381.01,284.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M362.07,310.43c9.92,22.71,37.27-11.36,37.27-11.36S363.96,287.86,362.07,310.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M432.79,253.61L432.79,253.61l29.77-33.63c18.88-23,22.68-32.76,22.79-32.91l-5.36-2.61 c-0.09,0.2-3.67,9.57-22.23,32.15l-27.48,29.87c-9.71-2.74-27.83-5.82-30.53,11.16C405.87,275.02,423.96,261.6,432.79,253.61z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/loaderLogo.9c4a92fc1dff981d4933735bb521cbcb.svg";
export { ForwardRef as ReactComponent };